import * as R from 'ramda';
import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { setMinPrice, setMaxPrice } from '../../actions/filters';
import { FilterPrice, IFilterPriceProps } from '../../components/FilterPrice';

type TFilterPriceStateProps = Pick<IFilterPriceProps, 'value'>;
type TFilterPriceDispatchProps = Pick<IFilterPriceProps, 'setMin' | 'setMax'>;

export function mapStateToProps(state: IReduxState): TFilterPriceStateProps {
  const { jsonQuery } = state.filters;

  return {
    value: R.pathOr({}, ['price', 'value'], jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterPriceDispatchProps {
  return {
    setMin: (value: number | undefined) => dispatch(setMinPrice(value)),
    setMax: (value: number | undefined) => dispatch(setMaxPrice(value)),
  };
}

export const FilterPriceContainer = connect(mapStateToProps, mapDispatchToProps)(FilterPrice);
